module.exports = __webpack_public_path__ + "assets/c0e147012dfe58b46cb61673d94f9309.png";